import React from 'react'
import { Action } from 'redux'
import { ModalActions } from '../../reducers/modals/actionNames'

const openModal = (
  id: string,
  element: React.ReactElement,
  uid: string | undefined = undefined,
): IOpenModal => ({
  element,
  id,
  type: ModalActions.OpenModal,
  uid,
})

const openTooltip = (id: string) => {
  return {
    id,
    type: ModalActions.OpenTooltip,
  }
}

const closeTooltip = (id: string) => {
  return {
    id,
    type: ModalActions.CloseTooltip,
  }
}

export interface IOpenModal extends Action<ModalActions.OpenModal> {
  id: string
  element: React.ReactElement
  uid: string | undefined
}

export { openTooltip, closeTooltip }
export default openModal
